import { format } from 'date-fns';
import { DISPLAY_TIME_FORMAT_LONG } from './constants';

export const formatTime = (date: Date) => format(date, DISPLAY_TIME_FORMAT_LONG);
